import {
  CHECK_IF_MDN_SMS_CAPABLE_BEGIN,
  CHECK_IF_MDN_SMS_CAPABLE_SUCCESS,
  CHECK_IF_MDN_SMS_CAPABLE_FAILURE,
  GENERIC_ERROR_MESSAGE
} from "./types";
import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";

export const checkIfMDNisSMSCapable = encryptedMdn => async dispatch => {
  dispatch({ type: CHECK_IF_MDN_SMS_CAPABLE_BEGIN });

  try {
    const response = await API({
      method: "POST",
      url: ENDPOINTS.CHECK_IF_MDN_SMS_CAPABLE,
      data: { selectedMdn: encryptedMdn ? encryptedMdn : "" }
    });

    if (response && response.data) {
      if (response.data.hasOwnProperty("mdn") && response.data.hasOwnProperty("email")) {
        const payload = {
          ...response.data
        };

        if (response.data.sendPinToEmail) {
          payload.verifiedDevice = response.data.email;
        } else {
          payload.verifiedDevice = response.data.mdn;
        }
        payload.mdn = response.data.mdn;

        dispatch({ type: CHECK_IF_MDN_SMS_CAPABLE_SUCCESS, payload });
      } else {
        dispatch({ type: CHECK_IF_MDN_SMS_CAPABLE_FAILURE, payload: GENERIC_ERROR_MESSAGE });
      }
    }
  } catch (error) {
    dispatch({
      type: CHECK_IF_MDN_SMS_CAPABLE_FAILURE,
      payload: error.response.description || GENERIC_ERROR_MESSAGE
    });
  }
};
